// extracted by mini-css-extract-plugin
export default {"container":"_424493e","visuallySimilarWrapper":"_d7527c6a"};